import {
  Card,
  CardActionArea,
  Box,
  Stack,
  Typography,
  Chip,
} from "@mui/material";
import { fDateTime } from "../../utils/formatTime";

// Middle-truncate a UUID for the compact list summary (full id shows in the detail panel).
function shortId(id) {
  if (!id) return "-";
  return id.length > 14 ? `${id.slice(0, 8)}...${id.slice(-4)}` : id;
}

function DrawListItem({ draw, selected, onClick }) {
  const recorded = draw.status === "recorded";
  return (
    <Card
      variant="outlined"
      sx={{
        borderColor: selected ? "primary.main" : "divider",
        bgcolor: "background.paper",
      }}
    >
      <CardActionArea onClick={onClick} sx={{ p: 2 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} noWrap>
              {draw.competitionName || "Active tournament"}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {[draw.seasonLabel, draw.periodLabel].filter(Boolean).join(" · ")}
            </Typography>
          </Box>
          <Chip
            size="small"
            label={recorded ? "Draw recorded" : "Draw pending"}
            color={recorded ? "success" : "warning"}
            variant={recorded ? "filled" : "outlined"}
          />
        </Stack>

        <Box sx={{ mt: 1.5 }}>
          {recorded && draw.result ? (
            <>
              <Typography variant="body2" fontWeight={600} noWrap>
                {draw.result.winner_username ||
                  draw.result.winner_ref_id ||
                  shortId(draw.result.winner_user_id)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Drawn {fDateTime(draw.result.drawn_at) || "-"}
              </Typography>
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Not yet drawn
            </Typography>
          )}
        </Box>
      </CardActionArea>
    </Card>
  );
}

export default function DrawList({ draws, selectedId, onSelect }) {
  return (
    <Stack spacing={2}>
      {draws.map((draw) => (
        <DrawListItem
          key={draw.id}
          draw={draw}
          selected={draw.id === selectedId}
          onClick={() => onSelect(draw.id)}
        />
      ))}
    </Stack>
  );
}
